import { render, staticRenderFns } from "./ModalPaymentDetails.vue?vue&type=template&id=2dc67e9f&"
import script from "./ModalPaymentDetails.vue?vue&type=script&lang=ts&"
export * from "./ModalPaymentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports